

import { replaceBucketKeysWithUrlsInArray } from '@shootsta/client-aws-s3';
import {
  getDataArrayWithOrganisationIds,
  getDataArrayWithoutOrganisationIds } from
'../../utils';


const appendOrganisation = (data, getOrganisationId) => getOrganisationId ?
getDataArrayWithOrganisationIds(data, getOrganisationId) :
data;

const removeOrganisation = (data, getOrganisationId) => getOrganisationId ?
getDataArrayWithoutOrganisationIds(data) :
data;

export const processDataArrayBucketKeysReplacement = async ({
  apiClient,
  data,
  organisationId,
  getOrganisationId,
  substitutedKeys
}) => {
  const dataArrayWithOrganisation = appendOrganisation(data, getOrganisationId);

  const dataArrayWithReplacedKeys = await replaceBucketKeysWithUrlsInArray({
    apiClient,
    dataArray: dataArrayWithOrganisation,
    organisationId,
    substitutedKeys
  });

  return removeOrganisation(dataArrayWithReplacedKeys, getOrganisationId);
};